import { useState } from 'react';
import { useGraphStore } from '../../graph-view/services/graph-store';
import { useLocale } from '../i18n/LocaleProvider';
import { getDefaultSettingsWorkspaceSection, getSettingsWorkspaceSections } from '../services/settings-workspace-schema';
import { DeidentificationSettingsPanel } from './DeidentificationSettingsPanel';
import { SettingsSectionNav } from './SettingsSectionNav';

export function SettingsWorkspace({ open, onClose }: { open: boolean; onClose: () => void }) {
  const readonlyMode = useGraphStore((state) => state.readonlyMode);
  const { t } = useLocale();
  const [activeSectionId, setActiveSectionId] = useState(getDefaultSettingsWorkspaceSection());
  const sections = getSettingsWorkspaceSections(readonlyMode);

  if (!open) {
    return null;
  }

  return (
    <aside aria-label={t('settings.workspace.title')} className="floating-panel workspace-panel workspace-panel--settings" role="region">
      <header className="workspace-header">
        <div className="workspace-title-group">
          <h2>{t('settings.workspace.title')}</h2>
          <p className="workspace-subtitle">{t('settings.workspace.graphScoped')}</p>
        </div>
        <button className="hud-subtle-button" onClick={onClose} type="button">{t('close')}</button>
      </header>
      <div className="workspace-layout">
        <SettingsSectionNav activeSectionId={activeSectionId} onSelect={setActiveSectionId} sections={sections} />
        <section className="workspace-content">
          {activeSectionId === 'deidentification' ? (
            <DeidentificationSettingsPanel />
          ) : (
            <div aria-label={t('settings.future.title')} className="panel-card">
              <h3>{t('settings.future.title')}</h3>
              <p className="workspace-subtitle">{t('settings.future.description')}</p>
            </div>
          )}
        </section>
      </div>
    </aside>
  );
}
